<template>
  <div id="contrato-registra">
    <template>
      <v-btn color="lime darken-2" dark class="mb-3" @click="volver()">
        <v-icon right dark>arrow_back_ios</v-icon>Volver
      </v-btn>
    </template>
    <v-layout align-center justify-center>
      <v-flex lg10>
        <v-card>
          <v-container>
            <v-toolbar color="white" dark flat dense cad>
              <v-toolbar-title class="indigo--text"
                >Datos de contrato ssssssss</v-toolbar-title
              >
            </v-toolbar>
            <v-form>
              <v-container>
                <v-layout>
                  <v-flex>
                    <!-- INICIO DATOS DE CONTRATO -->
                    <data-contrato
                      :contratoId="id"
                      :tipeView="tipeView"
                    ></data-contrato>
                    <!-- TERMINO DATOS DE CONTRATO -->
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import DataContrato from "@/modules/configuration/proveedor/views/ContratoData.vue";

export default {
  name: "contrato-registra",
  components: {
    DataContrato,
  },
  // mixins: [validationMixin],
  props: {
    proveedor: {},
    show: Boolean,
    tipo: "",
  },

  data: () => ({
    tipeView: "",
    contratoId: "",
  }),

  computed: {},

  created() {
    //this.username = this.$route.params.username;
    //this.tipeView = this.$route.params.tipeView;
  },
  methods: {
    volver() {
      this.$router.back();
    },
  },
};
</script>
